import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { OrderList } from "primereact/orderlist";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContext } from "../../../App";
import { useMobile } from "../../../hooks/useMobile";
import {
  foodStationApi,
  useGetStationListQuery,
} from "../../../redux/services/foodStation";
import {
  useDeleteOptionGroupMutation,
  useDeleteOptionMutation,
  useImportOptionGroupMutation,
  useLazyGetOptionGroupDataQuery,
  useLazyGetStationDeletedOptionsListQuery,
  useLazyGetStationOptionInfoQuery,
  useLazyGetStationOptionsListQuery,
  usePermanentlyDeleteOptionGroupMutation,
  usePermanentlyDeleteOptionMutation,
  useRecoverOptionGroupMutation,
  useRecoverOptionMutation,
  useSaveGroupOrderMutation,
  useSaveOptionsOrderMutation,
  useUpdateOptionGroupMutation,
  useUpdateOptionMutation,
  useUploadImageMutation,
} from "../../../redux/services/foodStationOptions";
import { setLoading } from "../../../redux/slices/app.slice";
import {
  setSelectedMenuStation,
  setMenuItemsOpenedAcc,
} from "../../../redux/slices/stations.slice";
import {
  exportOptionGroupToCsv,
  parseOptionGroupCsvFile,
} from "../../../utils/csvHelper";
import getSubdomain from "../../../utils/getSubdomain";
import { shouldAutoDisableGroup } from "../../../utils/optionFilters";
import { getImageUrl } from "../../../utils/getImageUrl";

import NoImg from "../../../assets/no_img.svg";
import NoteIcon from "../../../assets/note.svg";

import * as styles from "./MenuItems.module.css";

import { classNames } from "primereact/utils";
import { ImportModal } from "../../../components/ImportModal/ImportModal";
import { useImportModal } from "../../../context/ImportModalContext";
import { ImportButton } from "../../../components/ImportButton/ImportButton";

const MenuItems = () => {
  const { showImportModal, setShowImportModal } = useImportModal();
  const showToast = useContext(ToastContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isMobile: isTablet } = useMobile(1024);
  const { isMobile } = useMobile(600);
  const [data, setData] = useState([]);
  const savedStation = useSelector((s) => s.stations.selectedMenuStation);
  const savedOpenedAcc = useSelector((s) => s.stations.menuItemsOpenedAcc);
  const [selectedStation, setSelectedStation] = useState(null);
  const [subStations, setSubStations] = useState([]);
  const [selectedSubStation, setSelectedSubStation] = useState(null);
  const isMultiStation = !!selectedStation?.is_multi;
  const subStationOptions =
    subStations?.length > 0 ? subStations : selectedStation?.sub_stations || [];

  const {
    data: stations,
    isSuccess: isGetStationsSuccess,
    isError: isGetStationsError,
  } = useGetStationListQuery(getSubdomain());

  const [
    getStationOptions,
    {
      data: stationOptions,
      isSuccess: isGetStationOptionsSuccess,
      isError: isGetStationOptionsError,
    },
  ] = useLazyGetStationOptionsListQuery();

  const [
    getStationDeletedOptions,
    {
      data: stationDeletedOptions,
      isSuccess: isGetStationDeletedOptionsSuccess,
      isError: isGetStationDeletedOptionsError,
    },
  ] = useLazyGetStationDeletedOptionsListQuery();

  const [
    saveGroupOrder,
    {
      isSuccess: isSaveGroupOrderSuccess,
      isError: isSaveGroupOrderError,
      error: saveGroupOrderError,
    },
  ] = useSaveGroupOrderMutation();

  const [updateOptionGroup] = useUpdateOptionGroupMutation();

  const [
    deleteOptionGroup,
    {
      isSuccess: isDeleteOptionGroupSuccess,
      isError: isDeleteOptionGroupError,
      error: deleteOptionGroupError,
    },
  ] = useDeleteOptionGroupMutation();

  const [
    permanentlyDeleteOptionGroup,
    {
      isSuccess: isPermanentlyDeleteOptionGroupSuccess,
      isError: isPermanentlyDeleteOptionGroupError,
    },
  ] = usePermanentlyDeleteOptionGroupMutation();

  const [
    recoverOptionGroup,
    {
      isSuccess: isRecoverOptionGroupSuccess,
      isError: isRecoverOptionGroupError,
    },
  ] = useRecoverOptionGroupMutation();

  const [
    recoverOption,
    { isSuccess: isRecoverOptionSuccess, isError: isRecoverOptionError },
  ] = useRecoverOptionMutation();

  const [
    permanentlyDeleteOption,
    {
      isSuccess: isPermanentlyDeleteOptionSuccess,
      isError: isPermanentlyDeleteOptionError,
    },
  ] = usePermanentlyDeleteOptionMutation();

  const [updateOption] = useUpdateOptionMutation();

  const [
    saveOptionsOrder,
    {
      isSuccess: isSaveOptionsOrderSuccess,
      isError: isSaveOptionsOrdersError,
      error: saveOptionsOrdersError,
    },
  ] = useSaveOptionsOrderMutation();

  const [
    deleteOption,
    {
      isSuccess: isDeleteOptionSuccess,
      isError: isDeleteOptionError,
      error: deleteOptionError,
    },
  ] = useDeleteOptionMutation();

  const [
    uploadImage,
    {
      isSuccess: isUploadImageSuccess,
      isError: isUploadImageError,
      error: uploadImageError,
    },
  ] = useUploadImageMutation();

  const [getOptionGroupData] = useLazyGetOptionGroupDataQuery();

  const [getStationOptionInfo] = useLazyGetStationOptionInfoQuery();

  const [
    importOptionGroup,
    {
      isSuccess: isImportOptionGroupSuccess,
      isError: isImportOptionGroupError,
      error: importOptionGroupError,
    },
  ] = useImportOptionGroupMutation();

  const uploadRef = useRef(null);
  const autoGroupDisableRef = useRef(false);
  const [openedAcc, setOpenedAcc] = useState(savedOpenedAcc);
  const [groupId, setGroupId] = useState(null);
  const [groupName, setGroupName] = useState(null);
  const [groupMode, setGroupMode] = useState(null);
  const [showDeleteGroupModal, setShowDeleteGroupModal] = useState(false);
  const [currentNoteItem, setCurrentNoteItem] = useState(null);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [optionId, setOptionId] = useState(null);
  const [optionName, setOptionName] = useState(null);
  const [showDeleteOptionModal, setShowDeleteOptionModal] = useState(false);
  const [optionMode, setOptionMode] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [menuItem, setMenuItem] = useState(null);

  const navigatingToEditRef = useRef(false);

  const saveMenuState = () => {
    navigatingToEditRef.current = true;
    dispatch(setSelectedMenuStation(selectedStation));
    dispatch(setMenuItemsOpenedAcc(openedAcc));
  };

  const goCreateGroup = () => {
    if (!selectedStation) return;
    saveMenuState();
    const params = new URLSearchParams({ station: String(selectedStation.id) });
    const fallbackSub = selectedSubStation || subStationOptions?.[0];
    if (fallbackSub?.id) params.set("subStation", String(fallbackSub.id));
    navigate(`groups/create?${params.toString()}`);
  };
  const goEditGroup = (group) => {
    if (!selectedStation) return;
    saveMenuState();
    navigate(
      `groups/${group.group_id}/edit?station=${selectedStation.id}`,
    );
  };
  const goCreateOption = (group) => {
    if (!selectedStation) return;
    saveMenuState();
    navigate(
      `groups/${group.group_id}/options/create?station=${selectedStation.id}`,
    );
  };
  const goEditOption = (option, groupData) => {
    if (!selectedStation) return;
    saveMenuState();
    const gid = groupData?.group_id || groupData?.group?.group_id;
    navigate(
      `options/${option.id}/edit?station=${selectedStation.id}&group=${gid}`,
    );
  };

  useEffect(() => {
    if (isGetStationsError) {
      showToast("error", "Station", "Unable to load stations");
      dispatch(setLoading(false));
    }
  }, [isGetStationsError]);

  useEffect(() => {
    if (isGetStationsSuccess && savedStation && !selectedStation) {
      const match = stations?.find((s) => s.id === savedStation.id);
      if (match) setSelectedStation(match);
    }
  }, [isGetStationsSuccess, savedStation]);

  useEffect(() => {
    return () => {
      if (!navigatingToEditRef.current) {
        dispatch(setSelectedMenuStation(null));
        dispatch(setMenuItemsOpenedAcc(null));
      }
    };
  }, []);

  useEffect(() => {
    if (selectedStation) {
      const stationSubStations = selectedStation?.sub_stations || [];
      setSubStations(stationSubStations);
      setSelectedSubStation(null);
      if (stationSubStations.length > 0) {
        setSelectedSubStation(stationSubStations[0]);
      }
      getStationOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
      getStationDeletedOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
    } else {
      setSubStations([]);
      setSelectedSubStation(null);
    }
  }, [selectedStation]);

  useEffect(() => {
    if (isGetStationOptionsError) {
      showToast("error", "Station Option", "Unable to load station options");
      dispatch(setLoading(false));
    }
  }, [isGetStationOptionsError]);

  useEffect(() => {
    if (isSaveGroupOrderSuccess)
      showToast("success", "Groups", "Order updated!");
  }, [isSaveGroupOrderSuccess]);

  useEffect(() => {
    if (isSaveGroupOrderError)
      showToast(
        "error",
        saveGroupOrderError?.status,
        saveGroupOrderError?.data?.message ||
          (saveGroupOrderError?.data?.errors && "Incorrect data"),
      );
  }, [isSaveGroupOrderError]);


  useEffect(() => {
    if (isDeleteOptionGroupSuccess) {
      showToast("success", "Group", "Group deleted!");
      setShowDeleteGroupModal(false);
      dispatch(
        foodStationApi.util.invalidateTags([
          { type: "FoodStations", id: "LIST" },
        ]),
      );
      getStationDeletedOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
    }
  }, [isDeleteOptionGroupSuccess]);

  useEffect(() => {
    if (isDeleteOptionGroupError)
      showToast(
        "error",
        deleteOptionGroupError?.status,
        deleteOptionGroupError?.data?.message,
      );
  }, [isDeleteOptionGroupError]);

  useEffect(() => {
    if (isImportOptionGroupSuccess) {
      showToast("success", "Group", "Group imported!");
      uploadRef.current.clear();
      setShowImportModal(false);
    }
  }, [isImportOptionGroupSuccess]);

  useEffect(() => {
    if (isImportOptionGroupError) {
      showToast(
        "error",
        importOptionGroupError?.status,
        importOptionGroupError?.data?.message,
      );
      uploadRef.current.clear();
    }
  }, [isImportOptionGroupError]);


  useEffect(() => {
    if (isSaveOptionsOrderSuccess)
      showToast("success", "Options", "Order updated!");
  }, [isSaveOptionsOrderSuccess]);

  useEffect(() => {
    if (isSaveOptionsOrdersError)
      showToast(
        "error",
        saveOptionsOrdersError?.status,
        saveOptionsOrdersError?.data?.message ||
          (saveOptionsOrdersError?.data?.errors && "Incorrect data"),
      );
  }, [isSaveOptionsOrdersError]);

  useEffect(() => {
    if (isDeleteOptionSuccess) {
      showToast("success", "Option", "Option deleted!");
      setShowDeleteOptionModal(false);
      dispatch(
        foodStationApi.util.invalidateTags([
          { type: "FoodStations", id: "LIST" },
        ]),
      );
    }
  }, [isDeleteOptionSuccess]);

  useEffect(() => {
    if (isDeleteOptionError)
      showToast(
        "error",
        deleteOptionError?.status,
        deleteOptionError?.data?.message,
      );
  }, [isDeleteOptionError]);

  useEffect(() => {
    if (isUploadImageSuccess) {
      setShowImageModal(false);
      showToast("success", "Option", "Image uploaded!");
    }
  }, [isUploadImageSuccess]);

  useEffect(() => {
    if (isUploadImageError)
      showToast(
        "error",
        uploadImageError?.status,
        uploadImageError?.data?.message ||
          (uploadImageError?.data?.errors && "Incorrect data"),
      );
  }, [isUploadImageError]);

  useEffect(() => {
    if (isGetStationOptionsSuccess) {
      setData((prev) => [...prev, ...stations]);
    }
  }, [isGetStationOptionsSuccess]);

  useEffect(() => {
    let tempData = isGetStationOptionsSuccess ? [...stationOptions] : [];

    if (isGetStationDeletedOptionsSuccess) {
      stationDeletedOptions.forEach((deletedGroup) => {
        const existingIndex = tempData.findIndex(
          (g) => g.group.group_id === deletedGroup.group.group_id,
        );
        if (existingIndex !== -1) {
          tempData[existingIndex] = {
            ...tempData[existingIndex],
            items: [...tempData[existingIndex].items, ...deletedGroup.items],
          };
        } else {
          tempData.push(deletedGroup);
        }
      });
    }

    tempData = tempData.map((group) => ({
      ...group,
      items: [...group.items].sort((a, b) => {
        return (a.isDeleted ? 1 : 0) - (b.isDeleted ? 1 : 0);
      }),
    }));
    setData(tempData);
  }, [
    isGetStationOptionsSuccess,
    stationOptions,
    isGetStationDeletedOptionsSuccess,
    stationDeletedOptions,
  ]);

  useEffect(() => {
    if (isPermanentlyDeleteOptionGroupError) {
      showToast(
        "error",
        "Option Group",
        "Unable to permanently delete option group",
      );
    }
  }, [isPermanentlyDeleteOptionGroupError]);

  useEffect(() => {
    if (isPermanentlyDeleteOptionGroupSuccess) {
      getStationDeletedOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
      setShowDeleteGroupModal(false);
    }
  }, [isPermanentlyDeleteOptionGroupSuccess]);

  useEffect(() => {
    if (isRecoverOptionGroupSuccess) {
      getStationDeletedOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
    }
  }, [isRecoverOptionGroupSuccess]);

  useEffect(() => {
    if (isRecoverOptionGroupError) {
      showToast("error", "Option Group", "Unable to recover option group");
    }
  }, [isRecoverOptionGroupError]);

  useEffect(() => {
    if (isPermanentlyDeleteOptionError) {
      showToast("error", "Option", "Unable to permanently delete option");
    }
  }, [isPermanentlyDeleteOptionError]);

  useEffect(() => {
    if (isPermanentlyDeleteOptionSuccess) {
      getStationDeletedOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
      getStationOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
      setShowDeleteOptionModal(false);
    }
  }, [isPermanentlyDeleteOptionSuccess]);

  useEffect(() => {
    if (isRecoverOptionSuccess) {
      getStationDeletedOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
      getStationOptions({
        id: selectedStation.id,
        subDomain: getSubdomain(),
      });
    }
  }, [isRecoverOptionSuccess]);

  useEffect(() => {
    if (isRecoverOptionError) {
      showToast("error", "Option", "Unable to recover option");
    }
  }, [isRecoverOptionError]);

  const onFileUpload = async (e) => {
    try {
      const file = e.files[0];
      const text = await file.text();
      const json = parseOptionGroupCsvFile(text);
      const resolvedSubStationId = isMultiStation
        ? selectedSubStation?.id
        : subStationOptions?.[0]?.id;

      if (!resolvedSubStationId) {
        showToast("error", "Sub-station", "Select sub-station before import");
        return;
      }

      json.subdomain = getSubdomain();
      json.sub_station_id = resolvedSubStationId;
      importOptionGroup(json);
    } catch (e) {
      console.error(e);
    }
  };

  const downloadCSVFile = (content, filename) => {
    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToCSV = async (rowData) => {
    try {
      const data = await getOptionGroupData(
        { id: rowData.group_id, subdomain: getSubdomain() },
        false,
      ).unwrap();
      const csvContent = exportOptionGroupToCsv(data);
      downloadCSVFile(csvContent, `${rowData.group_name}_export.csv`);
    } catch (error) {
      showToast("error", "Group", "Unable to export data");
    }
  };

  const openGroupDeleteModal = (rowData, mode) => () => {
    setGroupId(rowData.group_id);
    setGroupName(rowData.group_name);
    setGroupMode(mode);
    setShowDeleteGroupModal(true);
  };

  const openOptionDeleteModal = (rowData, mode) => () => {
    setOptionId(rowData.id);
    setOptionName(rowData.name);
    setOptionMode(mode);
    setShowDeleteOptionModal(true);
  };

  const openImageModal = (rowData) => () => {
    if (rowData.item.isDeleted) return;
    if (rowData.item.image_name) {
      setCurrentImage(getImageUrl(rowData.item.image_name));
    } else {
      setCurrentImage(NoImg);
    }
    setOptionId(rowData.item.id);
    setGroupId(rowData.group.group.group_id);
    setShowImageModal(true);
    setMenuItem(rowData.item);
  };

  const onImageSelect = (e) => {
    setCurrentImage(e.files[0].objectURL);
  };

  const onImageUpload = (e) => {
    uploadImage({
      id: selectedStation.id,
      subdomain: getSubdomain(),
      data: e.files[0],
      optionId: optionId,
      groupId: groupId,
      imageType: "ingredient",
    });
  };

  const moveGroupUp = (group, groups) => () => {
    const payload = {
      groups: [],
      station_id: selectedStation.id,
    };

    const sortedGroups = [...groups].sort(
      (a, b) => a.group.order - b.group.order,
    );

    const index = sortedGroups.findIndex(
      (item) => item.group.group_id === group.group.group_id,
    );

    if (index > 0) {
      [sortedGroups[index - 1], sortedGroups[index]] = [
        sortedGroups[index],
        sortedGroups[index - 1],
      ];
    }

    payload.groups = sortedGroups.map((item, idx) => ({
      id: item.group.group_id,
      order: idx + 1,
    }));

    setOpenedAcc(null);
    saveGroupOrder({
      payload,
      subDomain: getSubdomain(),
    });
  };

  const moveGroupDown = (group, groups) => () => {
    const payload = {
      groups: [],
      station_id: selectedStation.id,
    };

    const sortedGroups = [...groups].sort(
      (a, b) => (a.group.order ?? 0) - (b.group.order ?? 0),
    );

    const index = sortedGroups.findIndex(
      (item) => item.group.group_id === group.group.group_id,
    );

    if (index !== -1 && index < sortedGroups.length - 1) {
      [sortedGroups[index], sortedGroups[index + 1]] = [
        sortedGroups[index + 1],
        sortedGroups[index],
      ];
    }

    sortedGroups.forEach((item, idx) => {
      payload.groups.push({
        id: item.group.group_id,
        order: idx + 1,
      });
    });

    setOpenedAcc(null);
    saveGroupOrder({ payload, subDomain: getSubdomain() });
  };

  const onPermanentlyDeleteGroup = () => {
    permanentlyDeleteOptionGroup({
      id: groupId,
      subDomain: getSubdomain(),
    });
  };

  const onDeleteGroup = () => {
    deleteOptionGroup({
      id: groupId,
      subDomain: getSubdomain(),
    });
  };

  const onPermanentlyDeleteOption = () => {
    permanentlyDeleteOption({ id: optionId, subdomain: getSubdomain() });
  };

  const onDeleteOption = () => {
    deleteOption({ id: optionId, subdomain: getSubdomain() });
  };

  const itemTemplate = (rowData) => (item) => {
    return (
      <div className={styles.stationOptionItem}>
        <div className={styles.column1}>
          <i className="pi pi-align-justify"></i>
        </div>

        <div className={classNames(styles.nameCell)}>{item.name}</div>
        <div
          className={classNames(styles.imageCell)}
          onClick={openImageModal({ group: rowData, item })}
        >
          <div
            style={{
              background: `url(${getImageUrl(
                item.image_name,
              )}) 0% 0% / cover, url(${NoImg}) 0% 0% / cover`,
            }}
            className={styles.optionImage}
          ></div>
          <i className={`pi pi-pencil ${styles.imageEdit}`} />
        </div>
        <div className={classNames(styles.costCell)}>
          $ {item.cost.toFixed(2)}
        </div>
        <div className={classNames(styles.noteCell)}>
          <Button
            className={styles.noteBtn}
            icon={<img src={NoteIcon} width={24} />}
            onClick={() => {
              setCurrentNoteItem(item.note);
              setShowNoteModal(true);
            }}
          />
        </div>
        <div className={classNames(styles.activeCell)}>
          {item.visible ? (
            <Button
              icon="pi pi-eye"
              disabled={item.isDeleted}
              className={`p-button-text ${styles.activeBtn}`}
              size="large"
              onMouseUp={() => {
                updateOption({
                  id: item.id,
                  data: {
                    group_id: rowData.group.group_id,
                    visible: item.visible === "Active",
                  },
                  subDomain: getSubdomain(),
                });
                const allOtherInvisible = shouldAutoDisableGroup(
                  rowData.items,
                  item.id,
                );
                if (allOtherInvisible) {
                  autoGroupDisableRef.current = true;
                  updateOptionGroup({
                    id: rowData.group.group_id,
                    data: { active: false },
                    subDomain: getSubdomain(),
                  });
                }
              }}
            />
          ) : (
            <Button
              icon="pi pi-eye-slash"
              disabled={item.isDeleted}
              className={`p-button-text ${styles.activeBtn}`}
              size="large"
              onMouseUp={() => {
                updateOption({
                  id: item.id,
                  data: {
                    group_id: rowData.group.group_id,
                    visible: item.visible !== "Active",
                  },
                  subDomain: getSubdomain(),
                });
              }}
            />
          )}
        </div>
        <div className={classNames(styles.actionsCell)}>
          <div className={styles.optionActionsWrapper}>
            {item.isDeleted ? (
              <Button
                icon="pi pi-refresh"
                disabled={rowData.group.isDeleted}
                className={`p-button-text ${styles.editGroupBtn}`}
                onMouseDown={() =>
                  recoverOption({ id: item.id, subDomain: getSubdomain() })
                }
              />
            ) : (
              <Button
                icon="pi pi-pencil"
                className={`p-button-text ${styles.editOptionBtn}`}
                onMouseDown={() => goEditOption(item, rowData)}
              />
            )}
            <Button
              icon="pi pi-trash"
              disabled={rowData.group.isDeleted}
              className={`p-button-text ${styles.deleteOptionBtn}`}
              onMouseDown={openOptionDeleteModal(
                item,
                item.isDeleted ? "permanently" : "delete",
              )}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.pageHeader}>
        <div className={styles.headerContentContainer}>
          <h2>Menu Items Settings</h2>
          {isMobile && <ImportButton onClick={setShowImportModal} />}
        </div>
        {isGetStationsSuccess && (
          <Dropdown
            value={selectedStation}
            onChange={(e) => setSelectedStation(e.value)}
            options={stations?.toSorted((a, b) => a.name.localeCompare(b.name))}
            optionLabel="name"
            placeholder="Station"
            className={`${styles.dropdown}`}
            itemTemplate={(option) => {
              const subCount = option.sub_stations?.length ?? 0;
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {!!option.is_multi && subCount > 1 && (
                    <span
                      title={`${subCount} sub-stations`}
                      className={styles.multiBadge}
                    >
                      x{subCount}
                    </span>
                  )}
                  {option.name}
                </div>
              );
            }}
            valueTemplate={(option) => {
              if (!option) return <span>Station</span>;
              const subCount = option.sub_stations?.length ?? 0;
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {!!option.is_multi && subCount > 1 && (
                    <span
                      title={`${subCount} sub-stations`}
                      className={styles.multiBadge}
                    >
                      x{subCount}
                    </span>
                  )}
                  {option.name}
                </div>
              );
            }}
          />
        )}
      </div>
      <div className={styles.groupActions}>
        {selectedStation && (
          <>
            <Button
              className={styles.createGroupBtn}
              onClick={goCreateGroup}
            >
              <i className="pi pi-plus" />{" "}
              <span className={styles.createBtnText}>ADD OPTION GROUP</span>
            </Button>
            <div className={styles.menuItemsActionsWrapper}>
              <div className={styles.expandToggleWrapper}>
                <Button
                  icon="pi pi-angle-down"
                  label="EXPAND ALL"
                  className={`p-button-text ${styles.expandButton}`}
                  onClick={() => {
                    setOpenedAcc(
                      stationOptions?.length
                        ? stationOptions.map((_, index) => index)
                        : null,
                    );
                  }}
                />
                <Button
                  icon="pi pi-angle-up"
                  label="COLLAPSE ALL"
                  className={`p-button-text ${styles.collapseButton}`}
                  onClick={() => {
                    setOpenedAcc(null);
                  }}
                />
              </div>

              {!isMobile && <ImportButton onClick={setShowImportModal} />}
            </div>
          </>
        )}
      </div>
      {selectedStation ? (
        <div className={styles.accordion}>
          {isGetStationOptionsSuccess && (
            <Accordion
              activeIndex={openedAcc}
              multiple
              onTabClose={({ originalEvent, index }) => {
                const attr =
                  originalEvent.target.getAttribute("data-pc-section");
                if (attr !== "root" && attr !== "icon") {
                  setOpenedAcc(index);
                }
              }}
              onTabOpen={({ originalEvent, index }) => {
                const attr =
                  originalEvent.target.getAttribute("data-pc-section");
                if (attr !== "root" && attr !== "icon") {
                  setOpenedAcc(index);
                }
              }}
              onTabChange={({ originalEvent, index }) => {
                const attr =
                  originalEvent.target.getAttribute("data-pc-section");
                if (attr !== "root" && attr !== "icon") {
                  setOpenedAcc(index);
                }
              }}
            >
              {data.map((item, index, array) => {
                return (
                  <AccordionTab
                    key={`${item.group.group_id}-${
                      isTablet ? "mobile" : "desktop"
                    }`}
                    header={
                      <div className={styles.accordionHeader}>
                        <div>
                          <span>{item.group.group_name}</span>
                          {isMultiStation &&
                          (item.group.sub_station_name ||
                            subStations.find(
                              (subStation) =>
                                subStation.id === item.group.sub_station_id,
                            )?.name) ? (
                            <span className={styles.groupSubStationName}>
                              {` (${item.group.sub_station_name || subStations.find((subStation) => subStation.id === item.group.sub_station_id)?.name})`}
                            </span>
                          ) : null}
                          {/*{"  "}*/}
                          {/*<span>*/}
                          {/*  {item.group.allow_multiple === 1*/}
                          {/*    ? `( Multiple Choice MAX ${item.group.max_multiple} )`*/}
                          {/*    : "( Single Choice)"}*/}
                          {/*</span>*/}
                        </div>

                        <div className={styles.groupActionsWrapper}>
                          <Button
                            icon="pi pi-upload"
                            className={`p-button-text ${styles.editGroupBtn}`}
                            onClick={() => exportToCSV(item.group)}
                          />
                          <div className={styles.orderBtnsWrapper}>
                            <Button
                              icon="pi pi-arrow-up"
                              className={`p-button-text ${styles.orderBtn}`}
                              disabled={index === 0 || item.group.isDeleted}
                              onMouseDown={moveGroupUp(item, array)}
                            />
                            <Button
                              icon="pi pi-arrow-down"
                              className={`p-button-text ${styles.orderBtn}`}
                              disabled={
                                array.length - 1 === index ||
                                item.group.isDeleted
                              }
                              onMouseDown={moveGroupDown(item, array)}
                            />
                          </div>
                          <div className={styles.actionsWrapper}>
                            <Button
                              icon="pi pi-plus"
                              className={`p-button-text ${styles.addOptionBtn}`}
                              disabled={item.group.isDeleted}
                              onMouseDown={() => goCreateOption(item.group)}
                            />
                            {item.group.isDeleted ? (
                              <Button
                                icon="pi pi-refresh"
                                className={`p-button-text ${styles.editGroupBtn}`}
                                onMouseDown={() =>
                                  recoverOptionGroup({
                                    id: item.group.group_id,
                                    subDomain: getSubdomain(),
                                  })
                                }
                              />
                            ) : (
                              <Button
                                icon="pi pi-pencil"
                                className={`p-button-text ${styles.editGroupBtn}`}
                                onMouseDown={() => goEditGroup(item.group)}
                              />
                            )}
                            <Button
                              icon="pi pi-trash"
                              className={`p-button-text ${styles.deleteGroupBtn}`}
                              onMouseDown={openGroupDeleteModal(
                                item.group,
                                item.group.isDeleted ? "permanently" : "delete",
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <div key={isTablet ? "mobile" : "desktop"}>
                      {isTablet ? (
                        <div className={styles.cardList}>
                          <Button
                            className={styles.createBtn}
                            onClick={() => goCreateOption(item.group)}
                          >
                            <i className="pi pi-plus" />
                          </Button>
                          {item.items.map((option) => {
                            return (
                              <div key={option.id} className={styles.cardItem}>
                                <div className={styles.cardInfo}>
                                  <div
                                    style={{
                                      backgroundImage: `url(${getImageUrl(
                                        option.image_name,
                                      )})`,
                                    }}
                                    className={styles.cardImage}
                                    onClick={openImageModal({
                                      group: item,
                                      item: option,
                                    })}
                                  >
                                    <div>
                                      <i className="pi pi-pencil"></i>
                                    </div>
                                  </div>
                                  <div className={styles.info}>
                                    <div className={styles.name}>
                                      {option.name}
                                    </div>
                                    <div className={styles.subfield}>
                                      Cost: <em>${option.cost}</em>
                                    </div>
                                    <div
                                      onClick={() => {
                                        setCurrentNoteItem(option.note);
                                        setShowNoteModal(true);
                                      }}
                                      className={styles.subfield}
                                    >
                                      {option.note}
                                    </div>
                                  </div>
                                </div>
                                <div className={styles.actions}>
                                  {option.visible ? (
                                    <button
                                      className={styles.cardEditBtn}
                                      disabled={option.isDeleted}
                                      onClick={() => {
                                        updateOption({
                                          id: option.id,
                                          data: {
                                            group_id: item.group.group_id,
                                            visible: false,
                                          },
                                          subDomain: getSubdomain(),
                                        });
                                        const allOtherInvisible =
                                          shouldAutoDisableGroup(
                                            item.items,
                                            option.id,
                                          );
                                        if (allOtherInvisible) {
                                          autoGroupDisableRef.current = true;
                                          updateOptionGroup({
                                            id: item.group.group_id,
                                            data: { active: false },
                                            subDomain: getSubdomain(),
                                          });
                                        }
                                      }}
                                    >
                                      <i className="pi pi-eye" />
                                    </button>
                                  ) : (
                                    <button
                                      className={styles.cardEditBtn}
                                      disabled={option.isDeleted}
                                      onClick={() => {
                                        updateOption({
                                          id: option.id,
                                          data: {
                                            group_id: item.group.group_id,
                                            visible: true,
                                          },
                                          subDomain: getSubdomain(),
                                        });
                                      }}
                                    >
                                      <i className="pi pi-eye-slash" />
                                    </button>
                                  )}
                                  {option.isDeleted ? (
                                    <button
                                      className={styles.cardEditBtn}
                                      disabled={item.group.isDeleted}
                                      onClick={() =>
                                        recoverOption({
                                          id: option.id,
                                          subDomain: getSubdomain(),
                                        })
                                      }
                                    >
                                      <i className="pi pi-refresh" />
                                    </button>
                                  ) : (
                                    <button
                                      className={styles.cardEditBtn}
                                      onClick={() =>
                                        goEditOption(option, item.group)
                                      }
                                    >
                                      <i className="pi pi-pencil" />
                                    </button>
                                  )}
                                  <button
                                    className={styles.cardDeleteBtn}
                                    onClick={openOptionDeleteModal(
                                      option,
                                      option.isDeleted
                                        ? "permanently"
                                        : "delete",
                                    )}
                                    disabled={item.group.isDeleted}
                                  >
                                    <i className="pi pi-trash" />
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className={styles.listWrapper}>
                          <OrderList
                            key={`order-${isTablet}`}
                            dataKey="id"
                            value={item.items}
                            onChange={(e) => {
                              saveOptionsOrder({
                                payload: {
                                  options: e.value.map((item, index) => {
                                    return { id: item.id, order: index + 1 };
                                  }),
                                  group_id: item.group.group_id,
                                },
                                subDomain: getSubdomain(),
                              });
                            }}
                            header={
                              <div className={styles.header}>
                                <div className={styles.column1}></div>
                                <div
                                  className={classNames(styles.titleHeaderCell)}
                                >
                                  Title
                                </div>
                                <div
                                  className={classNames(styles.imageHeaderCell)}
                                >
                                  Image
                                </div>
                                <div
                                  className={classNames(styles.costHeaderCell)}
                                >
                                  Cost
                                </div>
                                <div
                                  className={classNames(styles.noteHeaderCell)}
                                >
                                  Note
                                </div>
                                <div
                                  className={classNames(
                                    styles.activeHeaderCell,
                                  )}
                                >
                                  Active
                                </div>
                                <div
                                  className={classNames(
                                    styles.actionsHeaderCell,
                                  )}
                                >
                                  Actions
                                </div>
                              </div>
                            }
                            itemTemplate={itemTemplate(item)}
                            dragdrop
                            className={styles.orderListItem}
                          ></OrderList>
                        </div>
                      )}
                    </div>
                  </AccordionTab>
                );
              })}
            </Accordion>
          )}

          {/* Delete group modal */}
          <Dialog
            closable={false}
            header={
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: "30px",
                }}
              >
                Are You Sure?
              </div>
            }
            blockScroll
            visible={showDeleteGroupModal}
            onHide={() => {
              setShowDeleteGroupModal(false);
            }}
            footer={() => (
              <div className="flex flex-column gap-2 justify-content-end">
                <Button
                  label="Delete"
                  className={`p-button-success ${styles.deleteDialogBtn}`}
                  onClick={
                    groupMode === "permanently"
                      ? onPermanentlyDeleteGroup
                      : onDeleteGroup
                  }
                />
                <Button
                  label="Cancel"
                  text
                  className={`p-button-success ${styles.cancelDialogBtn}`}
                  onClick={() => {
                    setShowDeleteGroupModal(false);
                  }}
                />
              </div>
            )}
            className={`p-fluid ${styles.groupDeleteModal}`}
          >
            <div className={styles.text}>
              <span>
                You want to {groupMode === "permanently" ? "permanently" : ""}{" "}
                delete option group <strong>{groupName}</strong>.
              </span>
              Confirm this action by pressing ‘Delete’ or cancel it.
            </div>
          </Dialog>

          {/* Delete option modal */}
          <Dialog
            closable={false}
            blockScroll
            header={
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: "30px",
                }}
              >
                Are You Sure?
              </div>
            }
            visible={showDeleteOptionModal}
            onHide={() => {
              setShowDeleteOptionModal(false);
            }}
            footer={() => (
              <div className="flex flex-column gap-2 justify-content-end">
                <Button
                  label="Delete"
                  className={`p-button-success ${styles.deleteDialogBtn}`}
                  onClick={
                    optionMode === "permanently"
                      ? onPermanentlyDeleteOption
                      : onDeleteOption
                  }
                />
                <Button
                  label="Cancel"
                  text
                  className={`p-button-success ${styles.cancelDialogBtn}`}
                  onClick={() => {
                    setShowDeleteOptionModal(false);
                  }}
                />
              </div>
            )}
            className={`p-fluid ${styles.groupDeleteModal}`}
          >
            <div className={styles.text}>
              <span>
                You want to {optionMode === "permanently" ? "permanently" : ""}{" "}
                delete option <strong>{optionName}</strong>.
              </span>
              Confirm this action by pressing ‘Delete’ or cancel it.
            </div>
          </Dialog>

          {/* Note Modal */}
          <Dialog
            header={
              <div style={{ fontSize: "30px", fontWeight: "700" }}>Note</div>
            }
            visible={showNoteModal}
            onHide={() => setShowNoteModal(false)}
            modal
            blockScroll
            closable
            className={styles.noteModal}
          >
            <p
              style={{
                fontSize: "18px",
              }}
            >
              {currentNoteItem || "No note available"}
            </p>
          </Dialog>

          {/* Image modal */}
          <Dialog
            blockScroll
            header={`${menuItem?.name} Image`}
            visible={showImageModal}
            onHide={() => {
              setShowImageModal(false);
            }}
            footer={() => (
              <div className={styles.imageModalFooter}>
                <p>Minimum image resolution 400x400px</p>
                <FileUpload
                  mode="basic"
                  onSelect={onImageSelect}
                  customUpload
                  uploadHandler={onImageUpload}
                  onUpload={() => {}}
                  accept="image/*"
                  selectedFileLabel="Upload"
                  className={styles.uploadBtn}
                />
              </div>
            )}
            className={`p-fluid ${styles.imageModal}`}
          >
            <form>
              <div className={styles.preview}>
                <div className={styles.cardWrapper}>
                  <div className={styles.optionCard}>
                    <div
                      style={{
                        background: `url(${currentImage}) 0% 0% / cover, url(${NoImg}) 0% 0% / cover`,
                      }}
                      className={styles.image}
                    ></div>
                  </div>
                </div>
              </div>
            </form>
          </Dialog>

          {/* Import Modal */}
          <ImportModal
            uploadRef={uploadRef}
            showImportModal={showImportModal}
            setShowImportModal={setShowImportModal}
            onFileUpload={onFileUpload}
          />
        </div>
      ) : (
        <div>Select station please</div>
      )}
    </div>
  );
};

export default MenuItems;
